// frontend/src/axios.js
import axios from 'axios';
import { getCookie } from './utils/csrf';

const API_BASE = '';

const axiosInstance = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 요청 인터셉터 추가
axiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');

        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }

        // FormData 전송 시 Content-Type을 제거해 브라우저가 boundary 포함한 multipart/form-data를 자동 설정하도록 함
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        // POST, PUT, DELETE 요청에 대해 CSRF 토큰 추가
        if (['post', 'put', 'delete'].includes(config.method)) {
            const csrfToken = getCookie('csrftoken');
            if (csrfToken) {
            config.headers['X-CSRFToken'] = csrfToken;
            }
        }

        return config;
    },
    error => Promise.reject(error)
);

// 응답 인터셉터 추가
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        // 토큰 만료 처리
        if (error.response?.status === 401 || error.response?.data?.detail === 'Invalid token.') {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
